import {
	ADMINGETKYCDOCUMENTLIST_SUCCESS,
	ADMINGETKYCDOCUMENTLIST_FAILED,
	RESET_ADMINGETKYCDOCUMENTLIST,
	LOADING_ADMINGETKYCDOCUMENTLIST,
	NETWORK_ERROR_ADMINGETKYCDOCUMENTLIST
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINGETKYCDOCUMENTLIST:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {}
			};
		case ADMINGETKYCDOCUMENTLIST_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload
			};
		case ADMINGETKYCDOCUMENTLIST_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload
			};
		case NETWORK_ERROR_ADMINGETKYCDOCUMENTLIST:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {}
			};
		case RESET_ADMINGETKYCDOCUMENTLIST:
			return (state = initialState);
		default:
			return state;
	}
};
